<script lang="ts" generics="IdType extends (string | number)">
	import type { IDropdownOption } from "$lib/def/util-types";
	import Input from "$lib/ui/form/Input.svelte";
	import Modal from "$lib/ui/shared/Modal.svelte";

	import { createEventDispatcher } from "svelte";
	
	export let source: Promise<IDropdownOption<IdType>[]>;
	// export let selected: IdType | undefined;
	
	let dispatch = createEventDispatcher<{ done: IdType | undefined}>();

	let filter: string;
</script>

<Modal on:close={() => dispatch('done')}>
	<div slot="header">
		<span class="headline-s bold">Choose one of the following</span>
		<Input placeholder="Filter" onInput={(e) => filter = (e.target as HTMLInputElement)?.value} />
	</div>
	<div class="max-w-600 m-auto">
		{#await source}
			<div>Loading...</div>
		{:then options}
			{#each options as option}
				{#if !filter || option.name?.toLowerCase().includes(filter.toLowerCase())}
					<div>
						<button class="button secondary" on:click={() => dispatch('done', option.id)}>{option.name ?? option.title} (#{option.id})</button>
					</div>
				{/if}
			{/each}
		{/await}
	</div>
</Modal>
